module.exports = __webpack_public_path__ + "static/media/lizinde_kagarama4.8e5a2c07.jpeg";